import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCalendarSvg } from "./IconCalendarSvg.mjs";
const IconCalendar = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCalendarSvg, ...iconProps });
};
export {
  IconCalendar
};
